export function extractDomain(uri: string): string {
  try {
    return new URL(uri).hostname;
  } catch {
    return uri.length > 30 ? uri.slice(0, 30) + '\u2026' : uri;
  }
}

export function clientDisplayName(clientName: string | null): string {
  return clientName ?? 'Unnamed client';
}
